module.exports = __webpack_public_path__ + "static/media/play.a7e404dd.svg";